import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Gender } from '@/enums/apiEnums.ts';
import { CameraVideoFilledShape } from '@/components/common/svg/shapes/CameraVideoShape.tsx';

interface PremiumButtonProps {
  onClick?: () => void;
  gender: Gender;
}

const PAGE_BG = 'rgb(245, 245, 245)';

const LikesListBanner = ({ onClick, gender }: PremiumButtonProps) => {
  const { t } = useTranslation();

  const isMale = gender === Gender.MALE;

  const titles = {
    [Gender.MALE]: {
      title: 'likes.title_m',
      subtitle: 'likes.subtitle_m',
      button: 'likes.paywall.btn_m'
    },
    [Gender.FEMALE]: {
      title: 'likes.title_f',
      subtitle: 'likes.subtitle_f',
      button: 'likes.paywall.btn_f'
    }
  };

  return (
    <>
      <div style={stickyTitleStyle}>
        <div style={titleStyle}>{t(titles[gender].title)}</div>
      </div>

      <div style={subtitleStyle}>{t(titles[gender].subtitle)}</div>

      <div style={stickyButtonStyle}>
        <motion.div
          whileTap={{ scale: 0.97 }}
          style={buttonInnerStyle}
          onClick={onClick}
        >
          {!isMale && <CameraVideoFilledShape style={{ marginRight: '8px' }} />}
          <span style={textStyle}>{t(titles[gender].button)}</span>
        </motion.div>
      </div>
    </>
  );
};

const stickyTitleStyle: CSSProperties = {
  position: 'sticky',
  top: -15,
  zIndex: 10,
  background: PAGE_BG,
  padding: '8px 0 4px',
  width: '100%'
};

const titleStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 590,
  color: '#000',
  textAlign: 'left'
};

const subtitleStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 510,
  color: '#787878',
  textAlign: 'left',
  padding: '2px 0',
  width: '100%'
};

const stickyButtonStyle: CSSProperties = {
  position: 'sticky',
  top: 13,
  zIndex: 9,
  background: PAGE_BG,
  paddingBottom: 12,
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
};

const buttonInnerStyle: CSSProperties = {
  width: '100%',
  height: '41px',
  borderRadius: '100px',
  display: 'flex',
  marginTop: '10px',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(90deg, #8681FA 0%, #D16FD9 100%)',
  cursor: 'pointer'
};

const textStyle: CSSProperties = {
  fontSize: '15px',
  color: '#FFF',
  fontWeight: 590,
  letterSpacing: '0.5px'
};

export default LikesListBanner;
